import { render } from "./Team_legal_m.vue?vue&type=template&id=7ddf0bdc&scoped=true"
import script from "./Team_legal_m.vue?vue&type=script&lang=js"
export * from "./Team_legal_m.vue?vue&type=script&lang=js"

import "./Team_legal_m.vue?vue&type=style&index=0&id=7ddf0bdc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7ddf0bdc"

export default script